module.exports = __webpack_public_path__ + "static/img/delete.aa8e7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/delete.png
// module id = TP7z
// module chunks = 2